import { useEffect, useRef, useState } from 'react';

import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

import { Button } from 'src/components/basicContent/_Button/Button';

import ChevronDownSvg from 'public/icons/ChevronDown.svg';
import PersonIconSvg from 'public/icons/Person.svg';

import { MenuLink } from '../../NavigationMenu';
import PersonalisedLinks from '../_HamburgerMenu/_PersonalisedLinks/_PersonalisedLinks';
import LoggedInButtons from '../_LoggedInButtons/_LoggedInButtons';

import styles from './_WelcomeDropdown.module.css';

type WelcomeDropdownProps = {
	fields: {
		PersonalisedLinks?: MenuLink[];
		NonSubscriberExcludedLinks?: MenuLink[];
		RegisteredUserExcludedLinks?: MenuLink[];
		WelcomeMessage?: Field<string>;
		LogOutText?: Field<string>;
	};
	authenticatedUserProfile?: AuthenticatedUserProfile;
};

export default function WelcomeDropdown(props: WelcomeDropdownProps) {
	const [isActive, setIsActive] = useState(false);

	const btn = useRef<HTMLButtonElement>(null);
	const menu = useRef<HTMLDivElement>(null);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
				setIsActive(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	if (!props.authenticatedUserProfile) {
		return <></>;
	}

	return (
		<div
			ref={containerRef}
			className={`${styles.welcomeDropdownContainer} ${isActive ? 'active' : ''} ${
				props.authenticatedUserProfile ? 'loggedIn' : 'loggedOut'
			}`}
		>
			<Button
				title="Authenticated User Profile"
				buttonRef={btn}
				className={styles.welcomeDropdownButton}
				onClick={(e) => {
					if (window.innerWidth < 1024) {
						return;
					}

					if (e?.currentTarget === btn.current) {
						setIsActive(!isActive);
					}
				}}
			>
				<span className={styles.person}>
					<PersonIconSvg />
				</span>

				<span className={styles.btnText}>
					{props.fields.WelcomeMessage?.value?.replace('$firstname$', props.authenticatedUserProfile.contact?.firstName ?? '')}
				</span>

				<span className={styles.chevron}>
					<ChevronDownSvg className={styles.iconPinkDark} />
				</span>
			</Button>

			<div ref={menu} className={styles.menu}>
				<PersonalisedLinks fields={props.fields} authenticatedUserProfile={props.authenticatedUserProfile} />

				<hr className={styles.divider} />

				<div className={styles.logoutButtonContainer}>
					<LoggedInButtons
						menuTriggerId="menu-trigger"
						LogOutText={props.fields.LogOutText}
						authenticatedUserProfile={props.authenticatedUserProfile}
					/>
				</div>
			</div>
		</div>
	);
}
